// extracted by mini-css-extract-plugin
module.exports = {"row":"styles_row__y0isd","reviews":"styles_reviews__6WOCQ"};